import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import {
  getAllLoansCashInCustomerRedux,
  getAllLoansCashOutCustomerRedux,
} from "../../../actions/index";

import { connect } from "react-redux";

import { DollarSign } from "react-feather";
import "./loan.css";
export class SingleCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: "",
      customerUid: "",
      showSuggestion: true,
      open: false,
      toggleModal: true,
      singleLot: null,
      time: "",
      category: "",
      subCategory: "",
      note: "",
      amount: "",
      expenseObj: null,
      cursor: -1,
    };
  }

  componentDidMount = async () => {
    this.props.getAllLoansCashInCustomerRedux(this.props.match.params.customer);
    this.props.getAllLoansCashOutCustomerRedux(
      this.props.match.params.customer
    );
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { expenses, cashIns, todaysCash } = this.props;
    let total = 0;
    let totalCashIns = 0;
    expenses.map((expense) => {
      total += parseInt(expense.amount);
    });
    cashIns.map((cashIn) => {
      totalCashIns += parseInt(cashIn.amount);
    });
    let all = [...expenses, ...cashIns];
    return (
      <Fragment>
        <Breadcrumb
          title={
            all.length > 0 &&
            String(all[all.length - 1].subCategory || "").replace(/^undefined-/, "")
          }
          parent="Loans"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid ln-page kd-cash kd-st--peach">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ln-card">
                <div className="card-header ln-card-header">
                  <h5 className="ln-card-title">
                    <i className="icofont-user-alt-3 ln-card-icon"></i>
                    {all.length > 0 && all[all.length - 1].subCategory}
                  </h5>
                </div>

                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="row">
                      <div className="col" style={{ padding: "0 8px" }}>
                        <div className="ln-table-wrap">
                          <table className="table ln-table">
                            <thead>
                              <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Note</th>
                                <th scope="col">Cash Out</th>
                              </tr>
                            </thead>
                            <tbody>
                              {expenses.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="ln-empty"><EmptyState>No cash out entries.</EmptyState></td>
                                </tr>
                              ) : (
                                expenses.map((expense, index) => (
                                  <tr key={index}>
                                    <td>{expense.date}</td>
                                    <td>{expense.note}</td>
                                    <td>
                                      <span className="ln-amount-pill">{expense.amount}Tk</span>
                                    </td>
                                  </tr>
                                ))
                              )}
                              <tr className="ln-total-row">
                                <td></td>
                                <td>Total</td>
                                <td>{total}Tk</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col" style={{ padding: "0 8px" }}>
                        <div className="ln-table-wrap">
                          <table className="table ln-table">
                            <thead>
                              <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Note</th>
                                <th scope="col">Cash In</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cashIns.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="ln-empty"><EmptyState>No cash in entries.</EmptyState></td>
                                </tr>
                              ) : (
                                cashIns.map((expense, index) => (
                                  <tr key={index}>
                                    <td>{expense.date}</td>
                                    <td>{expense.note}</td>
                                    <td>
                                      <span className="ln-amount-pill">{expense.amount}Tk</span>
                                    </td>
                                  </tr>
                                ))
                              )}
                              <tr className="ln-total-row">
                                <td></td>
                                <td>Total</td>
                                <td>{totalCashIns}Tk</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cashIns: state.loans.singleCustomerCashIns,
    expenses: state.loans.singleCustomerCashOuts,
  };
};

export default connect(mapStateToProps, {
  getAllLoansCashInCustomerRedux,
  getAllLoansCashOutCustomerRedux,
})(SingleCustomer);
